import { KeycloakRoute, REALM_INTERN } from '@europrocurement/l2d-keycloak';
import * as React from 'react';
import { Outlet } from 'react-router';

const TachesRoot = function () {
    return (
        <KeycloakRoute roles={REALM_INTERN}>
            <Outlet />
        </KeycloakRoute>
    );
};

export default TachesRoot;
